export default "__VITE_ASSET__Dxu1b8E2__";